import React, { MouseEvent, useCallback, useState } from 'react';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { Link } from 'react-router';

import { HangerList } from '@paragon/contract-library';
import { hasMaterialsEditPermission } from '@paragon/login-tools';
import { getDefaultHangerListGuid } from '@paragon/material-lists';

import { setDefaultHangerListGuid } from '../../../actions/defaultMaterialSelectionActions';
import {
  archiveHangerList,
  duplicateHangerList,
  renameHangerList,
  restoreHangerList,
} from '../../../actions/hangerListActions';
import { useAppSelector } from '../../hooks';
import { ListMenu } from '../ListMenu';
import { PossiblyArchivedListName } from '../PossiblyArchivedListName';
import { cardSx, defaultListIconSx, flexRowCenteredItemsSx } from './common/card-styles';
import { DefaultListIcon } from './common/DefaultListIcon';

export function HangerListCard(props: { value: HangerList }) {
  const defaultHangerListGuid = useAppSelector(getDefaultHangerListGuid);
  const hasEditPermission = useAppSelector(hasMaterialsEditPermission);

  const [menuPosition, setMenuPosition] = useState<null | { x: number; y: number }>(null);

  const onContextMenuRequested = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      setMenuPosition({ x: event.clientX, y: event.clientY });
    },
    [setMenuPosition],
  );

  return (
    <Card elevation={0} sx={cardSx}>
      <CardActionArea component={Link} to={`/hangerLists/${props.value.guid}`} onContextMenu={onContextMenuRequested}>
        <CardContent>
          <Typography variant="h6" sx={flexRowCenteredItemsSx} gutterBottom>
            <PossiblyArchivedListName name={props.value.name} isArchived={props.value.isArchived} />

            <DefaultListIcon
              type="hanger"
              visible={props.value.guid === defaultHangerListGuid}
              sx={defaultListIconSx}
            />
          </Typography>
          <Typography variant="body2">
            {props.value.hangerHardware.length} hanger{props.value.hangerHardware.length === 1 ? '' : 's'}
          </Typography>
        </CardContent>
      </CardActionArea>
      {hasEditPermission && (
        <ListMenu
          noun="hanger"
          list={props.value}
          anchor={menuPosition}
          onClose={() => setMenuPosition(null)}
          setDefaultListGuid={setDefaultHangerListGuid}
          archiveList={archiveHangerList}
          restoreList={restoreHangerList}
          duplicateList={duplicateHangerList}
          renameList={renameHangerList}
        />
      )}
    </Card>
  );
}
